// extracted by mini-css-extract-plugin
export default {"layout":"YTQSw8KrEZB3Bsh3nroE"};